import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scaleToSize, isFileTiny } from '../../../_helpers';
import s from './ContentShadow.scss';
export var ContentShadow = function (_a) {
    var content = _a.content, containerSize = _a.containerSize, children = _a.children, useSmallStage = _a.useSmallStage, className = _a.className;
    var isMobile = useContext(MobileContext);
    var shadowSize = scaleToSize(content, containerSize);
    var needsSmallStage = useSmallStage && isFileTiny(content, isMobile);
    if (!shadowSize || content.transparency) {
        return (React.createElement("div", { className: classnames(needsSmallStage && s['small-stage'], className) }, children));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: needsSmallStage ? {} : shadowSize, className: classnames(needsSmallStage && s['small-stage'], className) }, children),
        !needsSmallStage && (React.createElement("div", { style: shadowSize, className: s['shadow-anchor'] }))));
};
ContentShadow.displayName = 'ContentShadow';
export default ContentShadow;
//# sourceMappingURL=ContentShadow.js.map